import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

import defaultErrorHandler from "actions/global/default-error-handler";

import {
  MESSAGE_ADD,
  MESSAGE_DELETE,
  MESSAGE_FILTERS,
  MESSAGE_LIST,
  MESSAGE_LOADING,
  MESSAGE_UPDATE
} from "./types";
import { requestCommonSearch } from "../common/requests";

const localeUrl = `${settings.localeUrl}api/`;
const ENDPOINT = "message";


export const setLoading = (status) => ({
  type: MESSAGE_LOADING,
  payload: status
});

export const messageAdd = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}`, data)
    .then(response => {
      dispatch({
        type: MESSAGE_ADD,
        payload: response.data
      });
      callback(true);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const messageUpdate = (id, data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .put(`${localeUrl}${ENDPOINT}/${id}`, data)
    .then(response => {
      dispatch({
        type: MESSAGE_UPDATE,
        payload: response.data
      });
      callback(true);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const messageDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  axios
    .delete(`${localeUrl}${ENDPOINT}/${id}`)
    .then(() => {
      dispatch({
        type: MESSAGE_DELETE,
        payload: {
          id
        }
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const messageGetFilters = () => dispatch => {
  dispatch(setLoading(true));
  axios
    .get(`${localeUrl}${ENDPOINT}/filters`)
    .then(response => {
      dispatch({
        type: MESSAGE_FILTERS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const messageGetSearch = (
  pageNumber = 0,
  pageSize = 10,
  sort = "id,ASC",
  criteria = [],
) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, pageNumber, pageSize, sort, criteria, localeUrl)
    .then(response => {
      dispatch({
        type: MESSAGE_LIST,
        payload: response
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const messageGetSingle = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/search?page=0&size=1`, {
      criteria: [{
        fieldName: "id",
        fieldValue: id,
        searchOperation: filterTypes.EQUALS.value
      }]
    })
    .then(response => {
      dispatch(setLoading(false));
      let res = false;
      if (response && response.data && response.data.content && response.data.content.content && response.data.content.content[0]) {
        res = response.data.content.content[0];
      }
      callback(res);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};



// WEBPACK FOOTER //
// ./src/actions/message/requests.js